// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.financial-view {
  display: grid;
  gap: var(--ui-space-4);
}

.financial-hero,
.financial-panel {
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-xl);
  background: linear-gradient(150deg, rgba(255, 255, 255, 0.97), rgba(247, 251, 249, 0.94));
  box-shadow: var(--ui-elevation-1);
}

.financial-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(250px, 330px);
  gap: var(--ui-space-5);
  padding: clamp(1.1rem, 2vw, 1.6rem);
}

.financial-hero h2,
.financial-panel h3 {
  margin: 0;
  color: var(--ui-text);
}

.financial-hero h2 {
  font-size: clamp(1.55rem, 2.2vw, 2.1rem);
}

.financial-runtime-card {
  display: grid;
  align-content: center;
  gap: 0.55rem;
  padding: 1rem;
  border-radius: var(--ui-radius-lg);
  border: 1px solid rgba(20, 114, 79, 0.16);
  background: rgba(255, 255, 255, 0.74);
}

.financial-runtime-card small,
.financial-validation-row small,
.financial-summary-card small,
.financial-notes p,
.financial-notes li,
.financial-download-panel p,
.financial-runtime-meta,
.financial-download-meta {
  color: var(--ui-text-soft);
  line-height: 1.45;
}

.financial-runtime-meta {
  display: grid;
  gap: 0.25rem;
  padding-top: 0.35rem;
  font-size: 0.74rem;
  overflow-wrap: anywhere;
}

.financial-layout {
  display: grid;
  grid-template-columns: minmax(420px, 1.45fr) minmax(320px, 1fr);
  gap: var(--ui-space-4);
  align-items: start;
}

.financial-main,
.financial-side {
  display: grid;
  gap: var(--ui-space-4);
}

.financial-panel {
  padding: clamp(1rem, 1.8vw, 1.35rem);
}

.financial-panel-head {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: var(--ui-space-4);
}

.financial-panel-head.compact {
  margin-bottom: var(--ui-space-3);
}

.financial-kicker {
  margin: 0 0 0.35rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: var(--ui-accent);
}

.financial-status-pill {
  display: inline-flex;
  align-items: center;
  min-height: 1.85rem;
  padding: 0.3rem 0.65rem;
  border-radius: var(--ui-radius-pill);
  border: 1px solid rgba(29, 90, 124, 0.16);
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
  color: var(--ui-accent-strong);
  background: rgba(29, 90, 124, 0.07);
}

.financial-status-pill.ready {
  border-color: rgba(20, 114, 79, 0.22);
  color: var(--ui-success);
  background: rgba(20, 114, 79, 0.08);
}

.financial-status-pill.warning,
.financial-status-pill.planned {
  color: var(--ui-warning);
  border-color: rgba(149, 109, 21, 0.2);
  background: rgba(149, 109, 21, 0.08);
}

.financial-status-pill.danger {
  color: var(--ui-danger);
  border-color: rgba(156, 60, 50, 0.2);
  background: rgba(156, 60, 50, 0.08);
}

.financial-upload-card {
  display: grid;
  gap: 0.55rem;
  padding: 1rem;
  border: 1px dashed rgba(42, 78, 102, 0.28);
  border-radius: var(--ui-radius-lg);
  background: rgba(255, 255, 255, 0.72);
  cursor: pointer;
}

.financial-upload-card.selected {
  border-style: solid;
  border-color: rgba(20, 114, 79, 0.26);
  background: rgba(240, 251, 246, 0.84);
}

.financial-upload-card span {
  color: var(--ui-text-soft);
  overflow-wrap: anywhere;
}

.financial-upload-card input {
  width: 100%;
  color: var(--ui-text-soft);
}

.financial-helper-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: var(--ui-space-3);
}

.financial-helper-strip span {
  padding: 0.35rem 0.58rem;
  border: 1px solid rgba(42, 78, 102, 0.12);
  border-radius: var(--ui-radius-pill);
  color: var(--ui-text-soft);
  background: rgba(255, 255, 255, 0.66);
  font-size: 0.75rem;
  font-weight: 700;
}

.financial-detected-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--ui-space-3);
  margin-top: var(--ui-space-4);
}

.financial-summary-card {
  display: grid;
  gap: 0.25rem;
  min-height: 5rem;
  padding: 0.82rem 0.9rem;
  border: 1px solid rgba(42, 78, 102, 0.12);
  border-radius: var(--ui-radius-md);
  background: rgba(255, 255, 255, 0.72);
}

.financial-summary-card.ready {
  border-color: rgba(20, 114, 79, 0.2);
  background: rgba(240, 251, 246, 0.78);
}

.financial-summary-card.warning {
  border-color: rgba(149, 109, 21, 0.2);
  background: rgba(255, 249, 235, 0.78);
}

.financial-summary-card.danger {
  border-color: rgba(156, 60, 50, 0.2);
  background: rgba(255, 244, 242, 0.78);
}

.financial-summary-card span {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--ui-text-soft);
  text-transform: uppercase;
}

.financial-summary-card strong {
  color: var(--ui-text);
  overflow-wrap: anywhere;
}

.financial-summary-card small {
  font-size: 0.78rem;
}

.financial-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ui-space-3);
  margin-top: var(--ui-space-4);
  padding-top: var(--ui-space-3);
  border-top: 1px solid var(--ui-border);
}

.financial-actions .disabled {
  opacity: 0.48;
  pointer-events: none;
}

.financial-feedback {
  margin: var(--ui-space-3) 0 0;
  padding: 0.75rem 0.85rem;
  border-radius: var(--ui-radius-md);
  font-weight: 700;
}

.financial-feedback.error {
  color: var(--ui-danger);
  background: rgba(156, 60, 50, 0.08);
}

.financial-runtime-warning {
  margin-top: var(--ui-space-3);
  padding: 0.8rem 0.9rem;
  border: 1px solid rgba(149, 109, 21, 0.28);
  border-radius: var(--ui-radius-md);
  color: var(--ui-warning);
  background: rgba(255, 249, 235, 0.9);
}

.financial-runtime-warning ul {
  display: grid;
  gap: 0.35rem;
  margin: 0.45rem 0 0;
  padding-left: 1.1rem;
}

.financial-download-meta {
  display: block;
  margin-top: 0.65rem;
  font-size: 0.78rem;
  overflow-wrap: anywhere;
}

.financial-download-panel {
  display: flex;
  justify-content: space-between;
  gap: var(--ui-space-4);
  align-items: flex-start;
}

.financial-download-panel p {
  margin: 0.45rem 0 0;
}

.financial-sheet-list {
  display: grid;
  gap: 0.25rem;
  margin: 0.8rem 0 0;
  padding-left: 1.1rem;
  color: var(--ui-text-soft);
  font-size: 0.82rem;
}

.financial-sheet-list strong {
  color: var(--ui-text);
}

.financial-validation-list {
  display: grid;
  gap: var(--ui-space-3);
}

.financial-validation-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 0.75rem;
  align-items: start;
  padding: 0.72rem 0;
  border-bottom: 1px solid rgba(42, 78, 102, 0.1);
}

.financial-validation-row:last-child {
  border-bottom: 0;
}

.financial-validation-row strong,
.financial-validation-row small {
  display: block;
}

.financial-validation-row strong {
  color: var(--ui-text);
  font-size: 0.92rem;
}

.financial-validation-row small {
  margin-top: 0.15rem;
  font-size: 0.78rem;
  overflow-wrap: anywhere;
}

.financial-notes ul {
  display: grid;
  gap: 0.55rem;
  margin: 0;
  padding-left: 1.1rem;
}

.financial-notes p {
  margin: 0;
}

:root[data-theme='dark'] .financial-hero,
:root[data-theme='dark'] .financial-panel {
  color: var(--ui-text);
  background: linear-gradient(150deg, rgba(17, 35, 47, 0.96), rgba(13, 28, 39, 0.94));
}

:root[data-theme='dark'] .financial-runtime-card,
:root[data-theme='dark'] .financial-upload-card,
:root[data-theme='dark'] .financial-summary-card,
:root[data-theme='dark'] .financial-helper-strip span {
  background: rgba(9, 22, 32, 0.72);
  border-color: rgba(120, 163, 193, 0.28);
}

:root[data-theme='dark'] .financial-upload-card.selected {
  background: rgba(13, 42, 33, 0.72);
  border-color: rgba(79, 209, 152, 0.36);
}

:root[data-theme='dark'] .financial-summary-card.ready {
  background: rgba(13, 42, 33, 0.72);
}

:root[data-theme='dark'] .financial-summary-card.warning {
  background: rgba(48, 39, 17, 0.72);
}

:root[data-theme='dark'] .financial-summary-card.danger {
  background: rgba(50, 25, 24, 0.72);
}

:root[data-theme='dark'] .financial-runtime-warning {
  border-color: rgba(219, 175, 74, 0.36);
  background: rgba(48, 39, 17, 0.82);
}

@media (max-width: 1080px) {
  .financial-layout,
  .financial-hero {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 720px) {
  .financial-panel-head,
  .financial-actions {
    flex-direction: column;
    align-items: flex-start;
  }

  .financial-actions .btn,
  .financial-actions a {
    width: 100%;
    justify-content: center;
  }

  .financial-detected-grid {
    grid-template-columns: 1fr;
  }

  .financial-validation-row {
    grid-template-columns: 1fr;
  }

  .financial-download-panel {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/views-estados-financieros.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,kCAAkC;EAClC,kCAAkC;EAClC,yFAAyF;EACzF,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;;EAEE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;;;;;;;;EAQE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,+DAA+D;EAC/D,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;;EAEE,wBAAwB;EACxB,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,kCAAkC;EAClC,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,oCAAoC;EACpC,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;EACzC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,0CAA0C;EAC1C,kCAAkC;EAClC,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,qBAAqB;EACrB,mFAAmF;AACrF;;AAEA;;;;EAIE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".financial-view {\n  display: grid;\n  gap: var(--ui-space-4);\n}\n\n.financial-hero,\n.financial-panel {\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-xl);\n  background: linear-gradient(150deg, rgba(255, 255, 255, 0.97), rgba(247, 251, 249, 0.94));\n  box-shadow: var(--ui-elevation-1);\n}\n\n.financial-hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(250px, 330px);\n  gap: var(--ui-space-5);\n  padding: clamp(1.1rem, 2vw, 1.6rem);\n}\n\n.financial-hero h2,\n.financial-panel h3 {\n  margin: 0;\n  color: var(--ui-text);\n}\n\n.financial-hero h2 {\n  font-size: clamp(1.55rem, 2.2vw, 2.1rem);\n}\n\n.financial-runtime-card {\n  display: grid;\n  align-content: center;\n  gap: 0.55rem;\n  padding: 1rem;\n  border-radius: var(--ui-radius-lg);\n  border: 1px solid rgba(20, 114, 79, 0.16);\n  background: rgba(255, 255, 255, 0.74);\n}\n\n.financial-runtime-card small,\n.financial-validation-row small,\n.financial-summary-card small,\n.financial-notes p,\n.financial-notes li,\n.financial-download-panel p,\n.financial-runtime-meta,\n.financial-download-meta {\n  color: var(--ui-text-soft);\n  line-height: 1.45;\n}\n\n.financial-runtime-meta {\n  display: grid;\n  gap: 0.25rem;\n  padding-top: 0.35rem;\n  font-size: 0.74rem;\n  overflow-wrap: anywhere;\n}\n\n.financial-layout {\n  display: grid;\n  grid-template-columns: minmax(420px, 1.45fr) minmax(320px, 1fr);\n  gap: var(--ui-space-4);\n  align-items: start;\n}\n\n.financial-main,\n.financial-side {\n  display: grid;\n  gap: var(--ui-space-4);\n}\n\n.financial-panel {\n  padding: clamp(1rem, 1.8vw, 1.35rem);\n}\n\n.financial-panel-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n  margin-bottom: var(--ui-space-4);\n}\n\n.financial-panel-head.compact {\n  margin-bottom: var(--ui-space-3);\n}\n\n.financial-kicker {\n  margin: 0 0 0.35rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  color: var(--ui-accent);\n}\n\n.financial-status-pill {\n  display: inline-flex;\n  align-items: center;\n  min-height: 1.85rem;\n  padding: 0.3rem 0.65rem;\n  border-radius: var(--ui-radius-pill);\n  border: 1px solid rgba(29, 90, 124, 0.16);\n  font-size: 0.72rem;\n  font-weight: 700;\n  white-space: nowrap;\n  color: var(--ui-accent-strong);\n  background: rgba(29, 90, 124, 0.07);\n}\n\n.financial-status-pill.ready {\n  border-color: rgba(20, 114, 79, 0.22);\n  color: var(--ui-success);\n  background: rgba(20, 114, 79, 0.08);\n}\n\n.financial-status-pill.warning,\n.financial-status-pill.planned {\n  color: var(--ui-warning);\n  border-color: rgba(149, 109, 21, 0.2);\n  background: rgba(149, 109, 21, 0.08);\n}\n\n.financial-status-pill.danger {\n  color: var(--ui-danger);\n  border-color: rgba(156, 60, 50, 0.2);\n  background: rgba(156, 60, 50, 0.08);\n}\n\n.financial-upload-card {\n  display: grid;\n  gap: 0.55rem;\n  padding: 1rem;\n  border: 1px dashed rgba(42, 78, 102, 0.28);\n  border-radius: var(--ui-radius-lg);\n  background: rgba(255, 255, 255, 0.72);\n  cursor: pointer;\n}\n\n.financial-upload-card.selected {\n  border-style: solid;\n  border-color: rgba(20, 114, 79, 0.26);\n  background: rgba(240, 251, 246, 0.84);\n}\n\n.financial-upload-card span {\n  color: var(--ui-text-soft);\n  overflow-wrap: anywhere;\n}\n\n.financial-upload-card input {\n  width: 100%;\n  color: var(--ui-text-soft);\n}\n\n.financial-helper-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: var(--ui-space-3);\n}\n\n.financial-helper-strip span {\n  padding: 0.35rem 0.58rem;\n  border: 1px solid rgba(42, 78, 102, 0.12);\n  border-radius: var(--ui-radius-pill);\n  color: var(--ui-text-soft);\n  background: rgba(255, 255, 255, 0.66);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.financial-detected-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--ui-space-3);\n  margin-top: var(--ui-space-4);\n}\n\n.financial-summary-card {\n  display: grid;\n  gap: 0.25rem;\n  min-height: 5rem;\n  padding: 0.82rem 0.9rem;\n  border: 1px solid rgba(42, 78, 102, 0.12);\n  border-radius: var(--ui-radius-md);\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.financial-summary-card.ready {\n  border-color: rgba(20, 114, 79, 0.2);\n  background: rgba(240, 251, 246, 0.78);\n}\n\n.financial-summary-card.warning {\n  border-color: rgba(149, 109, 21, 0.2);\n  background: rgba(255, 249, 235, 0.78);\n}\n\n.financial-summary-card.danger {\n  border-color: rgba(156, 60, 50, 0.2);\n  background: rgba(255, 244, 242, 0.78);\n}\n\n.financial-summary-card span {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--ui-text-soft);\n  text-transform: uppercase;\n}\n\n.financial-summary-card strong {\n  color: var(--ui-text);\n  overflow-wrap: anywhere;\n}\n\n.financial-summary-card small {\n  font-size: 0.78rem;\n}\n\n.financial-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--ui-space-3);\n  margin-top: var(--ui-space-4);\n  padding-top: var(--ui-space-3);\n  border-top: 1px solid var(--ui-border);\n}\n\n.financial-actions .disabled {\n  opacity: 0.48;\n  pointer-events: none;\n}\n\n.financial-feedback {\n  margin: var(--ui-space-3) 0 0;\n  padding: 0.75rem 0.85rem;\n  border-radius: var(--ui-radius-md);\n  font-weight: 700;\n}\n\n.financial-feedback.error {\n  color: var(--ui-danger);\n  background: rgba(156, 60, 50, 0.08);\n}\n\n.financial-runtime-warning {\n  margin-top: var(--ui-space-3);\n  padding: 0.8rem 0.9rem;\n  border: 1px solid rgba(149, 109, 21, 0.28);\n  border-radius: var(--ui-radius-md);\n  color: var(--ui-warning);\n  background: rgba(255, 249, 235, 0.9);\n}\n\n.financial-runtime-warning ul {\n  display: grid;\n  gap: 0.35rem;\n  margin: 0.45rem 0 0;\n  padding-left: 1.1rem;\n}\n\n.financial-download-meta {\n  display: block;\n  margin-top: 0.65rem;\n  font-size: 0.78rem;\n  overflow-wrap: anywhere;\n}\n\n.financial-download-panel {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--ui-space-4);\n  align-items: flex-start;\n}\n\n.financial-download-panel p {\n  margin: 0.45rem 0 0;\n}\n\n.financial-sheet-list {\n  display: grid;\n  gap: 0.25rem;\n  margin: 0.8rem 0 0;\n  padding-left: 1.1rem;\n  color: var(--ui-text-soft);\n  font-size: 0.82rem;\n}\n\n.financial-sheet-list strong {\n  color: var(--ui-text);\n}\n\n.financial-validation-list {\n  display: grid;\n  gap: var(--ui-space-3);\n}\n\n.financial-validation-row {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 0.75rem;\n  align-items: start;\n  padding: 0.72rem 0;\n  border-bottom: 1px solid rgba(42, 78, 102, 0.1);\n}\n\n.financial-validation-row:last-child {\n  border-bottom: 0;\n}\n\n.financial-validation-row strong,\n.financial-validation-row small {\n  display: block;\n}\n\n.financial-validation-row strong {\n  color: var(--ui-text);\n  font-size: 0.92rem;\n}\n\n.financial-validation-row small {\n  margin-top: 0.15rem;\n  font-size: 0.78rem;\n  overflow-wrap: anywhere;\n}\n\n.financial-notes ul {\n  display: grid;\n  gap: 0.55rem;\n  margin: 0;\n  padding-left: 1.1rem;\n}\n\n.financial-notes p {\n  margin: 0;\n}\n\n:root[data-theme='dark'] .financial-hero,\n:root[data-theme='dark'] .financial-panel {\n  color: var(--ui-text);\n  background: linear-gradient(150deg, rgba(17, 35, 47, 0.96), rgba(13, 28, 39, 0.94));\n}\n\n:root[data-theme='dark'] .financial-runtime-card,\n:root[data-theme='dark'] .financial-upload-card,\n:root[data-theme='dark'] .financial-summary-card,\n:root[data-theme='dark'] .financial-helper-strip span {\n  background: rgba(9, 22, 32, 0.72);\n  border-color: rgba(120, 163, 193, 0.28);\n}\n\n:root[data-theme='dark'] .financial-upload-card.selected {\n  background: rgba(13, 42, 33, 0.72);\n  border-color: rgba(79, 209, 152, 0.36);\n}\n\n:root[data-theme='dark'] .financial-summary-card.ready {\n  background: rgba(13, 42, 33, 0.72);\n}\n\n:root[data-theme='dark'] .financial-summary-card.warning {\n  background: rgba(48, 39, 17, 0.72);\n}\n\n:root[data-theme='dark'] .financial-summary-card.danger {\n  background: rgba(50, 25, 24, 0.72);\n}\n\n:root[data-theme='dark'] .financial-runtime-warning {\n  border-color: rgba(219, 175, 74, 0.36);\n  background: rgba(48, 39, 17, 0.82);\n}\n\n@media (max-width: 1080px) {\n  .financial-layout,\n  .financial-hero {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 720px) {\n  .financial-panel-head,\n  .financial-actions {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .financial-actions .btn,\n  .financial-actions a {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .financial-detected-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .financial-validation-row {\n    grid-template-columns: 1fr;\n  }\n\n  .financial-download-panel {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
